import React from "react";
import { Link, useLocation } from "react-router-dom";
import Logo from "./Logo";
import { Linkedin, Github, Mail, ArrowUpRight } from "lucide-react";
import { brand } from "../mock";

const Footer = () => {
  const { pathname } = useLocation();
  const isContactPage = pathname === "/contact";
  const cols = [
    { title: "Explore", links: [
      { label: "Home", to: "/" },
      { label: "Services", to: "/services" },
      { label: "Insights", to: "/insights" },
      { label: "About", to: "/about" },
      { label: "Contact", to: "/contact" },
    ]},
    { title: "Technical Expertise", links: [
      { label: "Microsoft Fabric", to: "/services" },
      { label: "Databricks", to: "/services" },
      { label: "Snowflake", to: "/services" },
      { label: "Power BI", to: "/services" },
      { label: "dbt", to: "/services" },
    ]},
  ];

  return (
    <footer className="bg-[#08132C] text-slate-300 pt-20 pb-8">
      <div className="container-x">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <Logo variant="dark" size={44} />
            <p className="mt-6 text-sm leading-relaxed text-slate-400 max-w-sm">
              (Re)Think Data. Think V4. Enterprise-grade data engineering, cloud modernization and AI-ready platforms — delivered end-to-end.
            </p>
            <div className="mt-6 flex items-center gap-3">
              <a href={brand.linkedin} target="_blank" rel="noreferrer" className="h-9 w-9 rounded-full border border-white/10 hover:border-[#1E56E3] hover:text-[#7CA6FF] flex items-center justify-center transition-colors"><Linkedin size={16} /></a>
              <a href={brand.github} target="_blank" rel="noreferrer" className="h-9 w-9 rounded-full border border-white/10 hover:border-[#1E56E3] hover:text-[#7CA6FF] flex items-center justify-center transition-colors"><Github size={16} /></a>
              <a href={`mailto:${brand.email}`} className="h-9 w-9 rounded-full border border-white/10 hover:border-[#1E56E3] hover:text-[#7CA6FF] flex items-center justify-center transition-colors"><Mail size={16} /></a>
            </div>
          </div>

          {cols.map((c) => (
            <div key={c.title} className="lg:col-span-2">
              <h4 className="text-white font-semibold text-sm">{c.title}</h4>
              <ul className="mt-4 space-y-2">
                {c.links.map((l) => (
                  <li key={l.label}><Link to={l.to} className="text-[13px] text-slate-400 hover:text-white transition-colors">{l.label}</Link></li>
                ))}
              </ul>
            </div>
          ))}

          {!isContactPage && <div className="lg:col-span-3">
            <h4 className="text-white font-semibold text-sm">Contact</h4>
            <ul className="mt-4 space-y-2 text-[13px] text-slate-400">
              <li><a href={`mailto:${brand.email}`} className="hover:text-white">{brand.email}</a></li>
            </ul>
            <Link to="/contact" className="mt-5 inline-flex items-center gap-1 text-sm font-semibold text-[#7CA6FF]">Start a project <ArrowUpRight size={16} /></Link>
            <Link
              to={brand.bookingPath}
              className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-white"
              data-testid="footer-book-appointment-button"
            >
              Book appointment <ArrowUpRight size={16} />
            </Link>
          </div>}
        </div>

        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="text-xs text-slate-500">© {new Date().getFullYear()} V4 Data And AI Solutions. All rights reserved.</div>
          <div className="flex items-center gap-6 text-xs text-slate-500">
            <Link to="/privacy" className="hover:text-white">Privacy Policy</Link>
            <Link to="/cookies" className="hover:text-white">Cookie Policy</Link>
            <Link to="/terms" className="hover:text-white">Terms</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
